import React, { useMemo } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import {Calendar } from 'lucide-react';
import "../css/dashboard/chart.css"

const AdminStatsChart = ({ doc, ec, nl }) => {

    const combined1 = [...doc, ...ec, ...nl].flat();

    // Filter and Aggregate Data
    const chartData = useMemo(() => {
        const combined = [...doc, ...ec, ...nl];
        const processingItems = combined.filter(item => item.docstatus === 'completed');
    
        const counts = processingItems.reduce((acc, item) => {
            let managers = item.managed_By;
    
            if (Array.isArray(managers) && managers.length > 0) {
                // 1. Convert all names to lowercase, trim them, and SORT them alphabetically
                const normalizedGroup = managers
                    .map(m => (typeof m === 'string' ? m : (m.name || '')).toLowerCase().trim())
                    .filter(m => m !== "") // remove empty strings
                    .sort()                // "ram, jay" becomes "jay, ram"
                    .join(', ');           // Create a unique string key for the group
    
                if (normalizedGroup) {
                    acc[normalizedGroup] = (acc[normalizedGroup] || 0) + 1;
                }
            } else if (typeof managers === 'string' && managers.trim() !== "") {
                // Fallback for single strings
                const name = managers.toLowerCase().trim();
                acc[name] = (acc[name] || 0) + 1;
            } else {
                acc['unassigned'] = (acc['unassigned'] || 0) + 1;
            }
            return acc;
        }, {});
    
        // 2. Format for Recharts and apply TitleCase
        return Object.keys(counts).map(name => ({
            // Your TitleCase function will turn "jay, ram" into "Jay, Ram"
            name: name.toLocaleUpperCase(), 
            value: counts[name]
        }));
    }, [doc, ec, nl]);


    // Distinct colors for the donut sections
    const totalFiles = chartData.reduce((sum, item) => sum + item.value, 0);
    const totalFiles1 = combined1.length;
    const COLORS = ['#8b5cf6', '#06b6d4', '#ec4899', '#f59e0b', '#10b981'];

    return (
        <div className="admin-chart-card">
            <div className="chart-header">
                <div className="title-area">
                    <h3 className="chart-title">Total Workload Distribution(Completed)</h3>
                    <span className="time-badge">
                        <Calendar size={12} /> Total Records: {totalFiles1}
                    </span>
                </div>
            </div>

            <div className="chart-wrapper" style={{ position: 'relative', height: '350px' }}>
                <div style={{
                    position: 'absolute',
                    top: '30%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    textAlign: 'center',
                    pointerEvents: 'none'
                }}>
                    <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#1e293b' }}>{totalFiles}</span>
                </div>
                <ResponsiveContainer width="100%" height={250}>
                    <PieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={80}
                            paddingAngle={5}
                            dataKey="value"
                        >
                            {chartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip 
                            contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                        />
                        <Legend verticalAlign="bottom" height={36}/>
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default AdminStatsChart;